import React, { memo } from 'react'
import { ITagProps, Tag, TAG_SIZE } from 'transfix-ui/components/Tag'
import { ICarrierApplicationStates, Maybe } from 'types/graphqlTypes'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { TEST_IDS } from '../../../../constants'
import { getStatusTagLabel, getStatusTagStyle } from './utils'

export interface ICarrierStatusTagProps extends Omit<ITagProps, 'label' | 'tagStyle'> {
  status: Maybe<ICarrierApplicationStates>
}

const CarrierStatusTag = memo<ICarrierStatusTagProps>(({ status, ...rest }) => {
  const isUseNewStateTagsEnabled = useFeatureFlag('useNewCarrierStatusTags')
  const tagLabel = getStatusTagLabel(status, isUseNewStateTagsEnabled)
  const tagStyle = getStatusTagStyle(status)

  return (
    <Tag
      label={tagLabel}
      tagStyle={tagStyle}
      size={TAG_SIZE.xsmall}
      dataTest={TEST_IDS.carrierStatusTag}
      {...rest}
    />
  )
})

export default CarrierStatusTag
